export default "__VITE_ASSET__895ed18f__"